import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"


import { withAuth } from "../../components/Auth"
import { Heading } from "../../components/Heading"
import { SubscribeForm } from "../../components/Subscriptions"

import Layout from "../Layout/Layout"


function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component"
}


export function requiresSubscriptionOrProduct(WrappedComponent, {productNames}) {
  /*
  HOC that gates content to require subscriptions
  */
  class RequiresSubscriptionOrProduct extends Component {
    constructor(props) {
      super(props)
      this.state = {
        hasSubscriptions: false,
        isClient: false
      }
    }

    componentDidMount() {
      this.setState({isClient: true})
    }

    hasSubscriptions() {
      let ownedProducts = this.props.ownedProducts || []
      let subscriptions = this.props.subscriptions || []
      let ownedItems = ownedProducts.concat(subscriptions)
      let matchedProducts = productNames.filter(value => ownedItems.includes(value))
      if (matchedProducts.length) {
        return true
      }
    }

    render() {
      let {isClient} = this.state
      if (!isClient) {
        return <></>
      }
      if (this.hasSubscriptions()) {
        return <WrappedComponent {...this.props}/>
      } else {
        return (
          <Layout showClouds>
            <div className="card">
              <Heading level={1} modifiers={["major"]}>Subscription Required</Heading>
              <p>Subscribe with your own account to access to access premium features, provide your cloud credentials and deploy in your own cloud accounts.</p>
            </div>
            <SubscribeForm compact productNames={productNames}/>
          </Layout>
        )
      }
    }
  }

  RequiresSubscriptionOrProduct.displayName = `RequiresSubscriptionOrProduct(${getDisplayName(WrappedComponent)})`

  RequiresSubscriptionOrProduct.propTypes = {
    ownedProducts: PropTypes.arrayOf(PropTypes.string),
    subscriptions: PropTypes.arrayOf(PropTypes.string),
  }

  RequiresSubscriptionOrProduct.defaultProps = {
    ownedProducts: [],
    subscriptions: [],
  }

  const mapStateToProps = state => ({
    ownedProducts: state.ownedProducts,
    subscriptions: state.subscriptions
  })

  return withAuth(connect(mapStateToProps)(RequiresSubscriptionOrProduct))
}


export default requiresSubscriptionOrProduct
